import { Injectable } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { PaypalPage } from '../models/cart-data.model';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutService } from './checkout.service';
declare var paypal: any;
@Injectable({
  providedIn: 'root',
})
export class PaypalService {
  public Page: string = ''; // 'cart';
  env: string = ''; //'sandbox'; // sandbox | production
  vistekUrl: string;

  constructor(
    private appConfigService: AppConfigService,
    private toaster: ToastService,
    private checkoutService: CheckoutService
  ) {
    // Init Model
    this.vistekUrl = this.appConfigService.vistekUrl;
    this.env = this.appConfigService.paypalEnvironment;
  }
  public renderPaypalButton(paypalBtnId: string) {
    var me = this;
    paypal.Button.render(
      {
        env: me.env, // sandbox | production
        style: {
          label: 'paypal', // checkout | credit | pay | buynow | generic
          size: 'responsive', // small | medium | large | responsive
          shape: 'rect', // pill | rect
          color: 'gold', // gold | blue | silver | black
          tagline: false,
        },
        // Show the buyer a 'Pay Now' button in the checkout flow
        commit: false,
        // payment() is called when the button is clicked
        payment: function () {
          // Call server to set up the payment
          console.log('PaypalService:payment:Call server to set up the payment');
          let createUrl = '/cart/checkout/paypal/create';

          let targetUrl = `${me.vistekUrl}${createUrl}`;

          return paypal.request.post(targetUrl).then(function (data) {
            if (data.Error) {
              // unable to continue.
              me.toaster.error(data.Error, 'Paypal Error');
              console.log('payment:Paypal error !!!');
            }
           // console.log('payment:data');
           // console.log(data);
            return data.PaymentID;
          });
        },
        // onAuthorize() is called when the buyer approves the payment
        onAuthorize: function (data, actions) {
          // Set up the data
          var postData = {
            PaymentID: data.paymentID,
            PayerID: data.payerID,
          };
         // console.log('onAuthorize:data');
          // console.log(data);
          // Server to execute the payment
          //let expressUrl = '/cart/checkout/paypal/express/start';
          let expressUrl =
            me.Page == PaypalPage.Checkout ? '/cart/checkout/paypal/express' : '/cart/checkout/paypal/express/start';
          let targetUrl = `${me.vistekUrl}${expressUrl}`;
          return paypal.request.post(targetUrl, postData).then(function (res) {
            if (me.Page == PaypalPage.Cart && res.CheckoutUrl) {
              window.location.href = `${me.vistekUrl}${res.CheckoutUrl}`;
              return;
            }
            if (me.Page == PaypalPage.Checkout) {
              console.log('onAuthorize: Checkout : result');
              console.log(res.Model);
              me.checkoutService.PaypalPaymentSubject.next(res.Model);
            }
          });
        },
        onCancel: function (data, actions) {
          // Show a cancel page or return to cart
        },
        onError: function (data, actions) {
          console.log('onError:Paypal error !!!');
          console.log('onError:actions', actions);
          console.log('onError:data', data);
          // unable to continue.
          me.toaster.error('Paypal is unable to process this payment, please contract Customer Support', 'Paypal Error');
        },
      },
      '#' + paypalBtnId
    );
  }
}
